export const BADGE_CONFIG = {
  new:        { label: 'Ny sjåfør',         icon: '⭐', color: '#888' },
  experienced:{ label: 'Erfaren sjåfør',    icon: '🌟', color: '#27ae60' },
  verified:   { label: 'Verifisert sjåfør', icon: '✅', color: '#27ae60' },
  top:        { label: 'Toppsjåfør',        icon: '🏆', color: '#f39c12' },
  warning:    { label: 'Advarsel',          icon: '⚠️', color: '#e67e22' },
  suspended:  { label: 'Suspendert',        icon: '🚫', color: '#e63946' },
};

export function computeBadge({ completedOrders = 0, cancellationTimestamps = [], tippiVerified = false }) {
  if (tippiVerified === true) return 'verified';

  const ninetyDaysAgo = Date.now() - 90 * 24 * 60 * 60 * 1000;
  const recent = (cancellationTimestamps ?? []).filter(ts => {
    const ms = ts?.toDate ? ts.toDate().getTime()
             : ts?.seconds  ? ts.seconds * 1000
             : Number(ts);
    return ms > ninetyDaysAgo;
  }).length;

  if (recent >= 3) return 'suspended';
  if (recent >= 2) return 'warning';
  if (completedOrders >= 20 && recent === 0) return 'top';
  if (completedOrders >= 5  && recent === 0) return 'experienced';
  return 'new';
}
